export interface CategoryItem {
  name: string;
  url: string;
  icon: string;
  description: string;
}

export const categories: CategoryItem[] = [
  {
    name: "Shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    icon: "ri-footprint-line",
    description: "Trending sneakers, casual shoes, and footwear finds from the Vigorbuy spreadsheet",
  },
  {
    name: "Hoodies / Sweaters",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    icon: "ri-t-shirt-line",
    description: "Cozy hoodies, crewnecks, and sweaters curated from Vigorbuy spreadsheet collections",
  },
  {
    name: "T-Shirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    icon: "ri-shirt-line",
    description: "Graphic tees, vintage styles, and everyday essentials discovered on Vigorbuy spreadsheet",
  },
  {
    name: "Jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    icon: "ri-t-shirt-2-line",
    description: "Bomber jackets, denim, puffers, and outerwear picks from the Vigorbuy spreadsheet",
  },
  {
    name: "Pants / Shorts",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    icon: "ri-pantone-line",
    description: "Cargo pants, jeans, shorts, and bottomwear recommendations from Vigorbuy spreadsheet",
  },
  {
    name: "Headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    icon: "ri-base-station-line",
    description: "Caps, beanies, bucket hats, and stylish headwear spotted on Vigorbuy spreadsheet",
  },
  {
    name: "Sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    icon: "ri-links-line",
    description: "Coordinated outfit sets and matching collections sourced from Vigorbuy spreadsheet",
  },
  {
    name: "Underwear / Underpants",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    icon: "ri-contrast-drop-line",
    description: "Comfort essentials and premium underwear picks from the Vigorbuy spreadsheet",
  },
  {
    name: "Jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    icon: "ri-football-line",
    description: "Sports jerseys, team apparel, and athletic wear from Vigorbuy spreadsheet listings",
  },
  {
    name: "Accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    icon: "ri-vip-crown-line",
    description: "Watches, sunglasses, jewelry, and fashion accessories curated on Vigorbuy spreadsheet",
  },
  {
    name: "Bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    icon: "ri-briefcase-line",
    description: "Backpacks, crossbody bags, totes, and carry essentials from Vigorbuy spreadsheet",
  },
  {
    name: "Belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    icon: "ri-loop-left-line",
    description: "Leather belts, designer belts, and waist accessories found on Vigorbuy spreadsheet",
  },
  {
    name: "Perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    icon: "ri-drop-line",
    description: "Designer fragrances, niche perfumes, and scent collections from Vigorbuy spreadsheet",
  },
  {
    name: "Other Stuff",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    icon: "ri-more-line",
    description: "Miscellaneous finds, unique products, and hidden gems from the Vigorbuy spreadsheet",
  },
];